function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDocumentBlank = function SvgDocumentBlank(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Ebene 1",
    viewBox: "0 0 12.1 15.92",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon ionic-ios-document"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.28 3.94h3.62a.2.2 0 0 0 .2-.2c0-.35-.15-.69-.43-.91L8.64.3C8.41.11 8.12 0 7.82 0a.29.29 0 0 0-.29.29v2.89c0 .42.34.76.76.76Z",
    "data-name": "Pfad 1",
    style: {
      fill: "#414a5f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.49 3.18V0H1.27C.57 0 0 .57 0 1.27v13.37c0 .7.57 1.27 1.27 1.27h9.55c.7 0 1.27-.57 1.27-1.27V4.97H8.27c-.99 0-1.79-.8-1.79-1.79Z",
    "data-name": "Pfad 2",
    style: {
      fill: "#414a5f"
    }
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDocumentBlank);
export default ForwardRef;